/**
 * @generated SignedSource<<ad5640a81c7c7d6e6e1aae18026c9e79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TrainingSourceKind = "knowledge_base" | "web_crawl" | "%future added value";
export type WebCrawlScope = "domain" | "single_page" | "subpath" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TrainingSourceSettingsFormFragment$data = {
  readonly id: string;
  readonly kind: TrainingSourceKind;
  readonly metadata: {
    readonly web_crawl: {
      readonly config: {
        readonly excludeUrlGlobs: ReadonlyArray<string> | null;
        readonly scope: WebCrawlScope;
      };
    } | null;
  } | null;
  readonly name: string | null;
  readonly resyncPeriod: string | null;
  readonly url: string;
  readonly " $fragmentType": "TrainingSourceSettingsFormFragment";
};
export type TrainingSourceSettingsFormFragment$key = {
  readonly " $data"?: TrainingSourceSettingsFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceSettingsFormFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrainingSourceSettingsFormFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resyncPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrainingSourceMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TrainingSourceWebCrawlMetadata",
          "kind": "LinkedField",
          "name": "web_crawl",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebCrawlConfig",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scope",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "excludeUrlGlobs",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TrainingSource",
  "abstractKey": null
};

(node as any).hash = "f0b1dd218aa2c340343dfaa2b4d3f405";

export default node;
